import { EvBattery } from "../vehicleDetails/vehicle-details.type";
import getBatteryGradeLetter from "./getBatteryGradeLetter";

export const getBatteryGradeData = (evBattery: EvBattery) => {
  if (!evBattery) {
    return "";
  }

  return evBattery.isApplicable
    ? !evBattery.batteryCondition
      ? "ungraded"
      : `grade-${getBatteryGradeLetter(evBattery.batteryCondition)}`
    : "untested";
};
